var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.48746 5.77601L6.38523 5.20047L8.8797 2.70552L7.2958 1.12111L4.80022 3.6155L4.22522 3.51328C3.71483 3.42178 3.18908 3.47351 2.70632 3.66272L6.33857 7.29431C6.52749 6.81168 6.57903 6.28615 6.48746 5.77601ZM4.12633 6.6671L0.956304 9.83593C0.851248 9.94098 0.708761 10 0.56019 10C0.411618 10 0.269132 9.94098 0.164076 9.83593C0.0590199 9.73088 2.71145e-09 9.58839 0 9.43983C-2.71145e-09 9.29126 0.0590198 9.14878 0.164076 9.04372L3.33354 5.8749L0.956304 3.49772C1.40307 3.05022 1.95155 2.71753 2.55486 2.52811C3.15818 2.33868 3.79839 2.29815 4.42077 2.40997L6.50246 0.328344C6.60652 0.224249 6.73006 0.141674 6.86604 0.0853354C7.00203 0.0289972 7.14777 0 7.29496 0C7.44215 0 7.5879 0.0289972 7.72388 0.0853354C7.85986 0.141674 7.98341 0.224249 8.08747 0.328344L9.67192 1.91331C9.88199 2.12344 10 2.4084 10 2.70552C10 3.00264 9.88199 3.28759 9.67192 3.49772L7.59024 5.57935C7.70207 6.20172 7.66153 6.84191 7.4721 7.44521C7.28267 8.04851 6.94998 8.59697 6.50246 9.04372L4.12633 6.6671Z",
    fill: "#535C64"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.57490bc0.svg";
export { ForwardRef as ReactComponent };